window.addEventListener('load', () => {
    function openNewWindow() {
        const contentContainer = document.getElementById('tool')
        const clonedContainer = contentContainer.cloneNode(true)
        clonedContainer.querySelectorAll('iframe').forEach(iframe => iframe.remove())
        const code = clonedContainer.innerHTML
        const newWindow = window.open('', '_blank', 'width=800,height=860')
        newWindow.document.write(code)
        newWindow.document.title = document.title
    }

    const openWindowBtn = document.getElementById('btn-detach')
    openWindowBtn && openWindowBtn.addEventListener('click', openNewWindow)
})